module.exports = __webpack_public_path__ + "static/002-cf58d90aa4ede9c0fdc9664e6da8dfee.jpg";